import { formatHHMM, truncateText } from "../../../utils";

const JobSummary = ({ job }) => {
    if (!job) return null;

    const {
        job_address,
        job_createdAt,
        job_eta_start_time,
        job_eta_end_time,
        job_check_in_time,
        job_check_out_time,
        job_description,
    } = job;

    const eta =
        job_eta_start_time && job_eta_end_time
            ? `${formatHHMM(job_eta_start_time)} to ${formatHHMM(job_eta_end_time)}`
            : "N/A";

    return (
        <div className="mx-3 mt-2">
            <ul className="list-unstyled mb-3">
                <SummaryRow label="Address" value={job_address} />
                <SummaryRow label="Created" value={job_createdAt} />
                <SummaryRow label="ETA" value={eta} />
                <SummaryRow label="Check-in" value={job_check_in_time} />
                <SummaryRow label="Check-out" value={job_check_out_time} />
            </ul>

            {job_description && (
                <p className="font-weight-bold mt-4">
                    {truncateText(`${job_description}`, 400)}
                </p>
            )}
        </div>
    );
};

const SummaryRow = ({ label, value }) => (
    <li className="d-flex justify-content-between align-items-center mb-2">
        <span className="text-sm font-weight-bold text-muted">
            {label}
        </span>
        <span className="text-md font-weight-bolder text-dark text-end ms-3">
            {value || "N/A"}
        </span>
    </li>
);

export default JobSummary;